import React from 'react';
import CreateFirmwareState from './createFirmwareState/CreateFirmwareState';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import CreationForm from './components/CreationForm/CreationForm';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

const CreateFirmwarePage: React.FC = () => {
	return (
		<CreateFirmwareState>
			<WithAdditionalValidationState>
				<CreationForm />
			</WithAdditionalValidationState>
			<ModalWindows />
		</CreateFirmwareState>
	);
};

export default CreateFirmwarePage;
